<template>
	<select class="form-control" :value="locale" @change="onChange" @focus="setOld">
		<option value="en">🇺🇸 English</option>
		<option value="ar">🇸🇦 Arabic</option>
	</select>
</template>


<script>
	import {mapState} from 'vuex';

	export default {
		data() {
			return {
				old: undefined,
			};
		},

		computed: {
			...mapState({
				locale: state => state.contentLocale,
			}),
		},

		methods: {
			onChange(e) {
				this.$emit('change', {oldValue: this.old, newValue: e.target.value});
				this.$store.dispatch('setContentLocale', e.target.value);
			},

			setOld(e) {
				this.old = e.target.value;
			}
		},
	};
</script>
